import { useCallback, useContext, useRef } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';
import { trackApplePayLoaded } from '@/utils/conversionTracking';
import type { ProviderEnum } from '@/types/common';

export const useApplePayLoadTracking = (provider: ProviderEnum): (() => void) => {
  const context = useContext(CheckoutContext);
  const contextRef = useRef(context);
  contextRef.current = context;
  const mountTimeRef = useRef(Date.now());

  return useCallback(() => {
    trackApplePayLoaded(contextRef.current, {
      payment_provider: provider,
      load_time_ms: Math.max(0, Math.round(Date.now() - mountTimeRef.current)),
    });
  }, [provider]);
};
